<template>
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.875"
      y="7.25"
      width="20.25"
      height="16.875"
      rx="2"
      stroke="url(#paint0_linear_3995_10669)"
      stroke-width="1.5"
    />
    <path
      d="M3.875 11.25C3.875 9.36438 3.875 8.42157 4.46079 7.83579C5.04657 7.25 5.98938 7.25 7.875 7.25H20.125C22.0106 7.25 22.9534 7.25 23.5392 7.83579C24.125 8.42157 24.125 9.36438 24.125 11.25V11.75H3.875V11.25Z"
      stroke="url(#paint1_linear_3995_10669)"
      stroke-width="1.5"
    />
    <path
      d="M8.375 3.875L8.375 7.25"
      stroke="url(#paint2_linear_3995_10669)"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M19.625 3.875L19.625 7.25"
      stroke="url(#paint3_linear_3995_10669)"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <rect
      x="8.375"
      y="14"
      width="4.5"
      height="2.25"
      rx="0.5"
      fill="url(#paint4_linear_3995_10669)"
      stroke="url(#paint5_linear_3995_10669)"
      stroke-width="0.2"
    />
    <rect
      x="8.375"
      y="18.5"
      width="4.5"
      height="2.25"
      rx="0.5"
      fill="url(#paint6_linear_3995_10669)"
      stroke="url(#paint7_linear_3995_10669)"
      stroke-width="0.2"
    />
    <rect
      x="15.125"
      y="14"
      width="4.5"
      height="2.25"
      rx="0.5"
      fill="url(#paint8_linear_3995_10669)"
      stroke="url(#paint9_linear_3995_10669)"
      stroke-width="0.2"
    />
    <rect
      x="15.125"
      y="18.5"
      width="4.5"
      height="2.25"
      rx="0.5"
      fill="url(#paint10_linear_3995_10669)"
      stroke="url(#paint11_linear_3995_10669)"
      stroke-width="0.2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3995_10669"
        x1="14"
        y1="7.25"
        x2="14"
        y2="24.125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3995_10669"
        x1="14"
        y1="7.25"
        x2="14"
        y2="11.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3995_10669"
        x1="8.375"
        y1="5.5625"
        x2="7.375"
        y2="5.5625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3995_10669"
        x1="19.625"
        y1="5.5625"
        x2="18.625"
        y2="5.5625"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3995_10669"
        x1="10.625"
        y1="14"
        x2="10.625"
        y2="16.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3995_10669"
        x1="10.625"
        y1="14"
        x2="10.625"
        y2="16.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3995_10669"
        x1="10.625"
        y1="18.5"
        x2="10.625"
        y2="20.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3995_10669"
        x1="10.625"
        y1="18.5"
        x2="10.625"
        y2="20.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3995_10669"
        x1="17.375"
        y1="14"
        x2="17.375"
        y2="16.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3995_10669"
        x1="17.375"
        y1="14"
        x2="17.375"
        y2="16.25"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_3995_10669"
        x1="17.375"
        y1="18.5"
        x2="17.375"
        y2="20.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_3995_10669"
        x1="17.375"
        y1="18.5"
        x2="17.375"
        y2="20.75"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
<style lang="scss" scoped></style>
